import type { EntityConfig } from '../types'

export const pointTransactionEntity: EntityConfig = {
  id: 'point-transaction',
  displayName: 'Point Transaction',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'earn', label: 'Earn' },
      { value: 'burn', label: 'Burn' },
      { value: 'expire', label: 'Expire' },
      { value: 'adjust', label: 'Adjust' },
      { value: 'transfer', label: 'Transfer' },
    ],
    options: [
      { value: 'earn', label: 'Earn', color: 'success' },
      { value: 'burn', label: 'Burn', color: 'error' },
      { value: 'expire', label: 'Expire', color: 'warning' },
      { value: 'adjust', label: 'Adjust', color: 'info' },
      { value: 'transfer', label: 'Transfer', color: 'neutral' },
    ],
    mappings: {
      all: ['earn', 'burn', 'expire', 'adjust', 'transfer'],
      earn: ['earn'],
      burn: ['burn'],
      expire: ['expire'],
      adjust: ['adjust'],
      transfer: ['transfer'],
    },
  },
  queryFields: {
    type: { type: 'status_array', urlKey: 'type' },
    source: { type: 'string_array', urlKey: 'source' },
    dateRange: { type: 'date_range', urlKey: 'dateRange' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['type', 'source', 'dateRange'],
}
